import React from 'react';

export const MyErotikaLogo = ({ size = 'md', className = '' }) => {
  const sizes = {
    sm: { my: 'text-[9px]', erotika: 'text-lg', bubble: 'px-1.5 py-0.5', gap: '-mb-0.5' },
    md: { my: 'text-[11px]', erotika: 'text-xl sm:text-2xl', bubble: 'px-2 py-0.5', gap: '-mb-1' },
    lg: { my: 'text-sm', erotika: 'text-3xl sm:text-4xl', bubble: 'px-2.5 py-1', gap: '-mb-1' },
    xl: { my: 'text-base', erotika: 'text-4xl sm:text-5xl lg:text-6xl', bubble: 'px-3 py-1', gap: '-mb-1.5' },
  };
  const s = sizes[size] || sizes.md;

  return (
    <span className={`inline-flex flex-col items-center leading-none ${className}`} data-testid="myerotika-logo">
      <span className={`${s.bubble} ${s.gap} bg-purple-main rounded-full rounded-bl-sm text-white font-bold ${s.my} tracking-wide z-10`}>
        My
      </span>
      <span className={`font-heading gradient-text ${s.erotika} tracking-wider`}>
        Erotika
      </span>
    </span>
  );
};
